import React from 'react';
import Styles from './Persona.module.less';
import { classes } from '../../../lib';
import { AnimatedStroke } from '../AnimatedStroke/AnimatedStroke';

export type PersonaStrokeColor = 'orange' | 'pink' | 'violet';

export type Stroke = PersonaStrokeColor | 'spiral';

export type PersonaMediaProps = {
    image: React.ReactNode;
    stroke?: Stroke;
    className?: string;
};

export const PersonaMedia = ({
    image,
    className,
    stroke,
}: PersonaMediaProps): JSX.Element => {
    if (!stroke)
        return (
            <div className={classes(className, Styles.imageWrapper)}>
                {image}
            </div>
        );

    return (
        <div
            className={classes(
                className,
                Styles.imageWrapper,
                Styles.paddedImageWrapper
            )}>
            {image}
            <div className={Styles.stroke}>
                <AnimatedStroke stroke={stroke} />
            </div>
        </div>
    );
};
